// Fi Exhaust
document.addEventListener("click", function (event) {
 document.querySelectorAll(".config-group").forEach((group) => {
  const buttons = group.querySelectorAll("button");
  const summaryKey = group.dataset.summary;

  buttons.forEach((button) => {
   button.addEventListener("click", () => {
    // Remove active state
    buttons.forEach((btn) => btn.classList.remove("active"));

    // Add active state
    button.classList.add("active");

    // Update summary
    const summaryElement = document.querySelector(`#summary-${summaryKey}`);

    if (summaryElement) {
     summaryElement.textContent = button.dataset.value;
    }
   });
  });
 });

 function initializeBuildSummary() {
  document.querySelectorAll(".config-group").forEach((group) => {
   const summaryKey = group.dataset.summary;
   const activeButton = group.querySelector("button.active");

   if (!activeButton) return;

   const summaryElement = document.querySelector(`#summary-${summaryKey}`);

   if (summaryElement) {
    summaryElement.textContent = activeButton.dataset.value;
   }
  });
 }

 initializeBuildSummary();

 function renderBuildSummary() {
  const container = document.getElementById("buildSummaryRows");

  let html = "";

  document.querySelectorAll(".config-group").forEach((group) => {
   const label = group.querySelector("h4").textContent;
   const activeButton = group.querySelector("button.active");

   if (!activeButton) return;

   html += `
            <div class="summary-row">
                <span>${label}</span>
                <strong>${activeButton.dataset.value}</strong>
            </div>
        `;
  });

  container.innerHTML = html;
 }

 document.addEventListener("click", function (e) {
  if (!e.target.matches(".config-group button")) return;

  const group = e.target.closest(".config-group");

  group
   .querySelectorAll("button")
   .forEach((btn) => btn.classList.remove("active"));

  e.target.classList.add("active");

  renderBuildSummary();
 });

 renderBuildSummary();
});

document.addEventListener("DOMContentLoaded", function () {
 const popup = document.getElementById("customExhaustModal");

 if (popup) {
  document.body.appendChild(popup);
 }
});

document.addEventListener("click", function (event) {
 const openButton = event.target.closest("[data-custom-exhaust-open]");
 const closeButton = event.target.closest("[data-custom-exhaust-close]");

 if (openButton) {
  event.preventDefault();

  const popup = document.getElementById("customExhaustModal");

  if (popup) {
   popup.classList.add("is-open");
   document.body.style.overflow = "hidden"; // Prevent page scrolling
  }
 }

 if (closeButton) {
  event.preventDefault();

  const popup = document.getElementById("customExhaustModal");

  if (popup) {
   popup.classList.remove("is-open");
   document.body.style.overflow = "scroll"; // Prevent page scrolling
  }
 }
});

document.addEventListener("keydown", function (event) {
 if (event.key === "Escape") {
  const popup = document.getElementById("customExhaustModal");

  if (popup && !popup.classList.contains(".is-open")) {
   popup.classList.remove("is-open");
   document.body.style.overflow = "scroll"; // Prevent page scrolling
  }
 }
});

document.addEventListener("DOMContentLoaded", () => {
 const form = document.querySelector(".build-request-form");
 const submitBtn = document.getElementById("submit_btn");
 const requiredFields = form.querySelectorAll("[required]");

 // Highlight field if invalid when leaving it
 requiredFields.forEach((field) => {
  field.addEventListener("blur", () => {
   if (!field.value.trim()) {
    field.classList.add("input-error");
   } else {
    field.classList.remove("input-error");
   }
  });

  // Remove error instantly once user fixes it
  field.addEventListener("input", () => {
   if (field.value.trim()) {
    field.classList.remove("input-error");
   }
  });
 });

 // On submit click
 submitBtn.addEventListener("click", () => {
  let hasError = false;

  requiredFields.forEach((field) => {
   if (!field.value.trim()) {
    field.classList.add("input-error");
    hasError = true;
   }
  });

  if (hasError) {
   return; // stop submission
  }

  submitQuote(); // only run if valid
 });
});

async function submitQuote() {
 emailjs.init("Hpsef5TC2Pb7vgQ52");
 const form = document.querySelector(".build-request-form");

 // Validate required fields
 //   if (!form.checkValidity()) {
 //     form.reportValidity();
 //     return;
 //   }

 const submitBtn = document.getElementById("submit_btn");

 submitBtn.disabled = true;
 submitBtn.textContent = "SENDING...";

 // Customer Information
 const firstName = document.getElementById("first_name").value?.trim() || "";
 const lastName = document.getElementById("last_name").value?.trim() || "";
 const custom_email =
  document.getElementById("custom_email").value?.trim() || "";
 const custom_phone =
  document.getElementById("custom_phone").value?.trim() || "";
 const custom_city = document.getElementById("custom_city").value?.trim() || "";
 const custom_country =
  document.getElementById("custom_country").value?.trim() || "";
 const vehicleYear =
  document.getElementById("vehicle_year").value?.trim() || "";
 const custom_vin = document.getElementById("custom_vin").value?.trim() || "";
 const custom_notes =
  document.getElementById("custom_notes").value?.trim() || "";

 // Build Configuration
 const catback = document.getElementById("summary-catback").textContent.trim();
 const downpipe = document
  .getElementById("summary-downpipe")
  .textContent.trim();
 const tips = document.getElementById("summary-tips").textContent.trim();
 const coating = document.getElementById("summary-coating").textContent.trim();
 const control = document.getElementById("summary-control").textContent.trim();
 const opf = document.getElementById("summary-opf").textContent.trim();

 const templateParams = {
  // Customer Information
  first_name: firstName,
  last_name: lastName,
  full_name: `${firstName} ${lastName}`,

  email: custom_email,
  phone: custom_phone || "Not Provided",
  city: custom_city || "Not Provided",
  country: custom_country || "Not Provided",
  vehicle_year: vehicleYear,
  vin: custom_vin || "Not Provided",
  notes: custom_notes || "No additional notes provided.",

  // Build Configuration
  catback: catback || "Not Selected",
  downpipe: downpipe || "Not Selected",
  tips: tips || "Not Selected",
  coating: coating || "Not Selected",
  control: control || "Not Selected",
  opf: opf || "Not Selected",

  submitted_at: new Date().toLocaleString(),
 };

 try {
  await emailjs.send("service_d9m4mc6", "template_4he0ntp", templateParams);

  alert("Quote request submitted successfully!");

  setTimeout(() => {
   window.location.reload();
  }, 800);

  submitBtn.textContent = "SEND QUOTE REQUEST";
  submitBtn.disabled = false;
 } catch (error) {
  console.error("EmailJS Error:", error);

  alert("There was an issue sending your quote request. Please try again.");

  submitBtn.textContent = "SEND QUOTE REQUEST";
  submitBtn.disabled = false;
 }
}
